const aragonIpfsGateway = 'https://ipfs.eth.aragon.network/'
const localIpfsGateway = 'http://localhost:8080'

export const defaultIpfsGateway = localIpfsGateway
